module.exports = __webpack_public_path__ + "static/ghost-6760b1867cdebdb34c3808e22667898f.mp4";